// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2MIUY","buttons":"PendingPaymentAlert_buttons__zlrYb"};